import React, { useState } from 'react'
import { Image } from 'primereact/image'

interface ImageProps {
  alt: string
  rounded?: '0' | '1' | '2' | '3' | '4' | '5'
  className?: string | undefined
  default: string
  height?: string
  src: string
  objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down'
  overflow?: 'visible' | 'hidden' | 'clip' | 'scroll' | 'auto'
  width?: string
  minWidth?: string
}

export default React.memo((props:ImageProps) => {
  const [imageError,setImageError] = useState<boolean>(false)
  const style = React.useMemo(() => ({
    'objectFit':props.objectFit,
    'overflow':props.overflow,
    'minWidth': props.minWidth,
  }),[props.objectFit,props.overflow])
  const pt = React.useMemo(() => ({
    'image':{ 'className':`rounded-${props.rounded}` },
  }),[props.rounded])
  return (
    <Image
      key={props.src}
      alt={props.alt}
      onError={(_) => setImageError(true)}
      src={imageError ? props.default : props.src}
      width={props.width}
      height={props.height}
      imageStyle={style}
      pt={pt}
    />
  )
})
